// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CustomerRate } from './customer-rate';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CustomerRateUpdate extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get isPending() {
    return !this.processed;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amount!: number;
  created!: Date;
  createdBy?: string;
  customerRateId!: number;
  deleted?: Date;
  deletedBy?: string;
  increaseDate!: Date;
  processed?: Date;
  customerRate!: CustomerRate;
}

